import React from "react";
import ImageTile from "./ImageTile";
import LinkTile from "./LinkTile";
import { User } from "~/common/Store/models/User";
interface Props {
  user: User;
}
export const Rewards = ({
  user
}: Props) => {
  const isUserRewardsMember = user.registered && user.isRewardsMember;
  return <div className="bg-gray-50 rounded" data-testid="ways-to-save-rewards" data-sentry-component="Rewards" data-sentry-source-file="Rewards.tsx">
      {isUserRewardsMember ? <ImageTile altText="Visa Rewards" link="/myaccount/" logo="/uploads/design/2022/1/Homepage/rewards_logo-card@2x.png" imageBackground="/uploads/design/2022/1/Homepage/rewards_bg@2x.png" /> : <ImageTile altText="Visa Rewards" link="/rewards/" logo="/uploads/design/2022/1/Homepage/rewards_logo-card@2x.png" imageBackground="/uploads/design/2022/1/Homepage/rewards_bg@2x.png" />}
      {isUserRewardsMember ? <LinkTile link="/myaccount/" linkText="Account Dashboard" description="Manage Your Webstaurant Rewards Visa® Card" /> : <LinkTile link="/rewards/" linkText="Learn More" description="Earn 3% back* per $1 spent at WebstaurantStore.com" />}
    </div>;
};
export default Rewards;